import { useMemo } from "react";

import { MOCK_CONSTRUCTOR_DOCUMENT_KITS } from "../../constructor-documents-page/constructor-documents-page.lib";
import { useServiceDetail } from "../hooks/use-service-detail";

/** Вкладка «Комплект документов»: комплекты по услуге (мок, макетом детально не задан). */
export const KitsTabContent = () => {
  const { service } = useServiceDetail();
  const kits = useMemo(() => MOCK_CONSTRUCTOR_DOCUMENT_KITS.filter((kit) => kit.service === service?.title), [service?.title]);

  return (
    <ul className="flex flex-col gap-3">
      {kits.length ? (
        kits.map((kit) => (
          <li key={kit.id} className="border-neutrals-95 flex items-center justify-between gap-6 rounded-xl border px-5 py-3">
            <div>
              <p className="subtitle-base text-type-common">{kit.road}</p>
              <p className="paragraph-sm text-type-minor">
                {kit.connectionType} · {kit.applicantType} · {kit.workTypesLabel}
              </p>
            </div>
            <p className="paragraph-base text-type-common">
              {kit.documentsTotal}, <span className="text-type-light">{kit.documentsRequired} обязательных</span>
            </p>
          </li>
        ))
      ) : (
        <p className="paragraph-base text-type-minor py-6 text-center">Комплектов документов для услуги пока нет</p>
      )}
    </ul>
  );
};
